import { Component, ElementRef, OnDestroy, ViewChild } from '@angular/core';
import { combineLatest, Observable, Subscription } from 'rxjs';
import { map } from 'rxjs/operators';
import { BusinessNavDataService } from '../../data.service';
import { SidebarService } from './sidebar.service';

@Component({
  selector: 'atlas-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnDestroy {
  isOpen$: Observable<boolean>;
  showOverlay$: Observable<boolean>;
  subs: Subscription[] = [];

  @ViewChild('sidebar', { static: true }) sidebarDom: ElementRef;


  constructor(private sidebarService: SidebarService, private apiService: BusinessNavDataService) {
    this.isOpen$ = this.sidebarService.open$;

    this.showOverlay$ = combineLatest(this.isOpen$, this.sidebarService.static$).pipe(
      map(([isOpen, isStatic]: [boolean, boolean]) => (isStatic) ? false : isOpen)
    );

    this.subs.push(
      this.sidebarService.static$.subscribe((isStatic: boolean) => {
        if (isStatic) {
          document.querySelector('body').style.setProperty('padding-left', '276px');
        } else {
          document.querySelector('body').style.setProperty('padding-left', '0');
        }
      })
    );

    setTimeout(() => {
      document.querySelector('body').style.setProperty('transition', 'padding-left 400ms');
      this.sidebarDom.nativeElement.style.transition = 'left 400ms';
    }, 20);
  }

  ngOnDestroy(): void {
    for (const sub of this.subs) {
      sub.unsubscribe();
    }
  }

  closeMenu(): void {
    this.sidebarService.setOpen(false);
  }
}
